import { Component } from '@angular/core';

@Component({
  selector: 'app-logout-complete',
  templateUrl: './logout-complete.component.html',
  styleUrl: './logout-complete.component.scss'
})
export class LogoutCompleteComponent {

}
